import { Box, Stack, Typography } from '@mui/material';

import TaskRow from '@/north-star/TaskRow';
import { HOME } from '@/north-star/NorthStar.content';
import { NEXT_TASKS } from '@/north-star/NorthStar.fixtures';

// Tasks tab content (the shell owns the status bar and nav). The full
// triage-driven list — the Attendance Allowance claim leads it (tapping it runs
// the claim form); the rest are the smaller bits Keni still needs.
export type NorthStarTasksProps = {
  onOpenTask: (id: string) => void;
  doneIds: Set<string>;
};

const NorthStarTasks = ({ onOpenTask, doneIds }: NorthStarTasksProps) => (
  <Box>
    <Typography variant='h4'>{HOME.tasksTitle}</Typography>
    <Stack sx={{ mt: 3 }} spacing={1.5}>
      {NEXT_TASKS.map((t) => (
        <TaskRow
          key={t.id}
          task={t}
          done={doneIds.has(t.id)}
          onClick={() => onOpenTask(t.id)}
        />
      ))}
    </Stack>
  </Box>
);

NorthStarTasks.displayName = 'NorthStarTasks';
export default NorthStarTasks;
